import { AlertTriangle, X } from "lucide-react"
import { Button } from "../../shadcn/button"

interface ModalHeaderProps {
  title: string;
  onClose: () => void;
  severity?: "warning" | "error" | "info";
  description?: string;
}

const ModalHeader = ({ 
  title, 
  onClose, 
  severity = "warning",
  description
}: ModalHeaderProps) => {
  // Icon and color configuration based on severity
  const iconConfig = {
    warning: {
      bgColor: "bg-amber-100 dark:bg-amber-900/40",
      iconColor: "text-amber-600 dark:text-amber-400",
      icon: AlertTriangle
    },
    error: {
      bgColor: "bg-red-100 dark:bg-red-900/40",
      iconColor: "text-red-600 dark:text-red-400",
      icon: AlertTriangle
    },
    info: {
      bgColor: "bg-blue-100 dark:bg-blue-900/40",
      iconColor: "text-blue-600 dark:text-blue-400",
      icon: AlertTriangle
    }
  };

  const { bgColor, iconColor, icon: Icon } = iconConfig[severity];

  return (
    <div className="flex flex-col p-4 sm:p-6 border-b dark:border-neutral-700">
      <div className="flex items-center justify-between mb-1">
        <div className="flex items-center gap-3">
          <div className={`${bgColor} p-2 rounded-full shrink-0`}>
            <Icon className={`h-5 w-5 ${iconColor}`} aria-hidden="true" />
          </div>
          <h2 className="text-xl font-semibold truncate dark:text-neutral-100">{title}</h2>
        </div>
        <Button 
          variant="ghost" 
          size="icon" 
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }} 
          className="h-8 w-8 rounded-full transition-colors hover:bg-destructive/10 hover:text-destructive dark:hover:bg-destructive/20 dark:text-neutral-300 dark:hover:text-destructive ml-2 shrink-0"
          aria-label="Close"
        >
          <X className="h-4 w-4" />
          <span className="sr-only">Fermer</span>
        </Button>
      </div>
      {description && (
        <p className="text-sm text-muted-foreground dark:text-neutral-400 pl-10">
          {description}
        </p>
      )}
    </div>
  )
}

export default ModalHeader